import React from 'react'
import { observer } from 'mobx-react-lite'
import { Instance } from 'mobx-state-tree'
import { ISelectorOption } from '@trivie/core'
import { SubscriptionGift } from '@trivie/core/src/models/subscriptions/SubscriptionGift'
import { AutocompleteSelector } from '../../../../components/autocomplete-selector'

type GiftSubscriptionUsersProps = {
  form: Instance<typeof SubscriptionGift>
  maxSelections?: number
  totalRecipients?: number
  maxRecipients?: number
}

export const GiftSubscriptionUsers = observer((props: GiftSubscriptionUsersProps) => {
  const { form, maxSelections, totalRecipients, maxRecipients } = props

  const handleSelectionChange = (selected: ISelectorOption[]) => {
    form.set('users', selected)
  }

  return (
    <AutocompleteSelector
      variant="users"
      showAvatar
      open
      placeholder="Search by name or email..."
      defaultOptions={[...(form.users as any)] as ISelectorOption[]}
      onSelectionChange={handleSelectionChange}
      style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
      maxSelections={maxSelections}
      helperText={
        maxRecipients != null && totalRecipients != null
          ? `${totalRecipients}/${maxRecipients} Users`
          : undefined
      }
      error={maxRecipients != null && totalRecipients != null && totalRecipients >= maxRecipients}
    />
  )
})
